import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GamedUpdating').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh',
    padding: '0px 24px',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },

  heading: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: '34px',
    letterSpacing: '-2%',
    textAlign: 'center',
    color: 'white',
  },

  description: {
    fontWeight: '250',
    fontSize: '13px',
    letterSpacing: '-1%',
    textAlign: 'center',
    color: 'white',
  },

  notation: {
    fontWeight: '350',
    fontSize: '17px',
    letterSpacing: '-1%',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  button: {
    gap: '8px',
    width: '90%',
    height: '52px',
  },

  btnText: {
    fontSize: '17px',
    fontWeight: 460,
    lineHeight: '24px',
  },
}))
